import React from "react";
import { Box } from "@mui/material";
import { ChannelList } from "stream-chat-react";

export default function ChannelSidebar({ streamUser }) {
  const filters = {
    type: "messaging",
    members: { $in: [streamUser.id] },
  };
  const sort = [{ pinned_at: -1, }, { last_message_at: -1 }];
  const options = { limit: 30 };

  return (
    <Box
      sx={{
        width: { xs: "100%", sm: 360 },
        borderRight: 1,
        borderColor: "divider",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          minWidth: 0,
          "& .str-chat__channel-list": { width: "100%", height: "100%" },
          "& .str-chat__channel-list-messenger": { width: "100%", height: "100%" },
          "& .str-chat__channel-list-messenger-react": {
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          },
          "& .str-chat__channel-list-messenger-react__main": {
            width: "100%",
            height: "100%",
            overflow: "auto",
          },
          "& .str-chat__channel-list-messenger__main": { width: "100%" },
          "& .str-chat__channel-preview-messenger": { width: "100%" },
        }}
      >
        <ChannelList filters={filters} sort={sort} options={options} setActiveChannelOnMount={false} showChannelSearch />
      </Box>
    </Box>
  );
}
